import i18n from 'i18next';
import { html, render } from 'lit-html';
import moment from 'moment';
import { getDecimal } from '../../../shared/components/chart/chart-helpers';
import { getState } from '../../../utils/state';
import { getUrlParams } from '../../../utils/url';
import AnalysisGeographical from '../../analysis/geographical/analysis-geographical';
import { exportDataProccess } from '../form/analysis-form-buttons';
import { geoParseDate, getAgg, getGeoAgg } from '../geographical/geo-utils';
import indicatorsComposited from '../geographical/queries/indicators_composited';
import indicatorsOperationDiv from '../geographical/queries/indicators_operation_div';
import indicatorsSimple from '../geographical/queries/indicators_simple';
import levelIndicatorsComposited from '../geographical/queries/level_indicators_composited';
import levelIndicatorsOperationDiv from '../geographical/queries/level_indicators_operation_div';
import levelIndicatorsSimple from '../geographical/queries/level_indicators_simple';
import { getCustomTime } from './analysis-compo-chart';
import { api } from '../../../utils/api-interceptor';
import AnalysisTitle from '../analysis-title';

const GeoChart = (analysis, indicatorInfo, datevalue = true) => {
  // Crear un objeto URL
  let { start_date, end_date, level } = getUrlParams();
  const indicator = indicatorInfo.indicator;
  const indicatorLevel = indicator.nivel[0].geo_nivel;

  if (indicatorLevel != null && indicatorLevel != level) {
    level = indicatorLevel;
    analysis.level = level;
  }
  let url = new URL(window.location.href);

  // Eliminar el parámetro 'geoids'
  url.searchParams.delete('geoids');
  url.searchParams.set('level', level);
  // Obtener la URL modificada sin el parámetro 'geoids'
  let newUrl = url.toString();
  window.history.replaceState(null, '', newUrl);
  render(
    AnalysisTitle(`${indicator.name} ${''}`),
    document.getElementById('analysis-info-title')
  );

  // Getting global common state
  const state = getState();
  // Current language we are using
  const lang = state.currentLang;

  const startDate = analysis.start_date || start_date;
  const endDate = analysis.end_date || end_date;
  let datetime =
    analysis.datetime || moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');

  if (datevalue) {
    datetime = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
  }
  const currentLevel = analysis.level || level || indicator.nivel[0].geo_nivel;
  let sqlParams = {
    id: indicator.id,
    start_date: moment(new Date(geoParseDate(startDate)))
      .tz('Europe/London')
      .format('YYYY-MM-DD HH:mm:ss'),
    end_date: moment(new Date(geoParseDate(endDate)))
      .tz('Europe/London')
      .format('YYYY-MM-DD HH:mm:ss'),
    agg: getAgg(indicator.magnitud[0].id),
    geo_agg: getGeoAgg(indicator.magnitud[0].id),
    decimals: getDecimal(indicator.magnitud[0].id) || 1,
    lang: lang,
    nivel: currentLevel,
    datetime,
    where_geoids: '',
  };
  // query for cartoCss
  let query;
  let geoIds = getUrlParams().geoids;
  // ! setting geoids
  if (geoIds) {
    sqlParams.where_geoids = ' AND geo_def.cartodb_id IN (' + geoIds + ') ';
  }

  if (currentLevel != indicatorLevel) {
    if (indicator.operation === 'DIV' && indicator.composited) {
      query = levelIndicatorsOperationDiv(sqlParams);
    } else if (indicator.composited) {
      query = levelIndicatorsComposited(sqlParams);
    } else {
      query = levelIndicatorsSimple(sqlParams);
    }
  } else {
    if (indicator.operation === 'DIV' && indicator.composited) {
      query = indicatorsOperationDiv(sqlParams);
    } else if (indicator.composited) {
      sqlParams.sons = indicatorInfo.compare || [];
      query = indicatorsComposited(sqlParams);
    } else {
      query = indicatorsSimple(sqlParams);
    }
  }

  let geotrunc = '';
  let nivel = state.analysis.levels;
  if (nivel == null) {
    nivel = state.analysis.level;
    if (state.analysis.level != null) {
      nivel = Number(nivel);
    }
  }
  if ((state.analysis.level == null && nivel == null) || nivel == 'NaN') {
    if (indicatorLevel == null) {
      nivel = 0;
      state.analysis.level = 0;
    } else {
      nivel = indicatorLevel;
    }
  }

  if (nivel == 0) {
    geotrunc = '&geo_trunc=country';
  } else if (nivel == 1) {
    geotrunc = '&geo_trunc=electric_system';
  } else if (nivel == 2) {
    geotrunc = '&geo_trunc=autonomous_community';
  } else if (nivel == 3) {
    geotrunc = '&geo_trunc=province';
  }
  let timeagg = '';
  if (sqlParams.agg === 'AVG') {
    timeagg = '&time_agg=avg';
  }

  api(
    `indicators/${indicator.id}?start_date=${
      startDate ? startDate : moment().tz('Europe/Madrid').format('DD-MM-YYYY')
    }&end_date=${
      endDate ? endDate : moment().tz('Europe/Madrid').format('DD-MM-YYYY')
    }&time_trunc=year&geo_red=sum${geotrunc}${timeagg}&locale=${i18n.t(
      'routes.lng'
    )}`
  ).then((datageored) => {
    // Aseguramos que tenemos datos antes de proceder
    // Verificamos si los datos tienen filas o no
    if (datageored.rows.length === 0) {
      const noData = `<div class="widget-nodata">
          <div>${i18n.t('no_data')}</div>
        </div>`;
      document.getElementById('geo-map-container-' + indicator.id).innerHTML =
        noData;
      document.getElementById('geo-legend').classList.add('is-hidden');
    } else {
      // Procesamos los datos si están disponibles
      // Exportamos datos después de procesarlos
      exportDataProccess('#analysis-btn', datageored, analysis);
      AnalysisGeographical(analysis, indicator, sqlParams, datageored);
    }
  });

  return html`
    <h2 class="info-chart-title">${getCustomTime(analysis)}</h2>
    <div id="geo-map-container-${indicator.id}">
      <div id="spinnergeo" style="display: flex;" class="spinner-container">
        <div class="spinner"></div>
      </div>
    </div>
    <div id="geo-legend" class="mod-analysis-map-legend is-hidden"></div>
  `;
};

export default GeoChart;
